<template>  
    <div id="menus-dropdown-comparator" class="center-element d-flex justify-content-center pt-0 mt-3">
        <div class="wrapper d-flex justify-content-center align-items-center w-100 gap-3 mb-3 flex-wrap">
            <div class="d-flex flex-row ">
                <div class="flex-col px-2">
                    <h6 class="text-center">Risk criteria</h6>
                    <div class="dropdown-1">
                    <IndicatorDropDown 
                    :data="data"
                    :title="'Indicator'" 
                    :queryTitle="'Select Indicator'" 
                    :titleV="'false'" 
                    :push="false"
                    :defaultIndicator="'overallcountryrisk'"
                    @submit="selectRiskIndicator"
                    />
                    </div>
                </div>

                <div class="flex-col">
                    <h6 class="text-center">Opportunity criteria</h6>
                    <div class="dropdown-1">
                    <IndicatorDropDown 
                    :dataOpport="dataOpport"
                    :title="'Indicator'" 
                    :queryTitle="'Select Indicator'" 
                    :titleV="'false'" 
                    :push="false"
                    :defaultIndicator="'opport'"
                    @submit="selectOpportIndicator"
                    />
                    </div>
            </div>
            </div>


            
            <span class="material-icons mt-4">compare_arrows</span>

                <div class="dropdown" v-if="regions.length > 0 && country.length > 0">
                  <div class="flex-col">
                    <h6 class="text-center">Region selection</h6>
                    <MenuDropDown
                    ref="menuDropDownRef"
                    :data="regions"
                    :dataorg="regionsorg"
                    :data_country="country"
                    :title="'Region'" 
                    :queryTitle="'Select Region'" 
                    :path="path" 
                    :push="false"
                    @submit="selectRegion"
                    />
                    </div>
                </div>
        </div>

    </div>

<div class="d-inline-block">

  <div style="text-align: center; margin-bottom: -8px; margin-right: -40px;">
    Sort by
  </div>

  <div class="d-flex flex-row">
    <p class="pt-3 ps-10">Risk</p>
    <div class="language-switcher">
      <label class="switch">
        <input type="checkbox" v-on:click="toggleSort()" />
        <span class="slider"></span>
      </label>
    </div>
    <p class="pt-3">Opportunity</p>
  </div>

</div>
    
    <div class="center-verticaly d-flex flex-column align-items-center justify-content-center" v-if="has_error">
        <AlertMessage @ERROR="error" :message="errorMessage" :type="'warning'"/>
    </div>
    <div class="d-flex flex-row">
      <!-- <div class=" align-items-center justify-content-center"> -->
        
    <div class="center-verticaly d-flex flex-column" style="width: 100%" v-if="regions.length > 0 && Object.keys(countriesData).length > 0">
        <ComparisonBar style="max-width:100%; max-height: 20rem" :id="'Risk-Comparison-Bar'" :regions="regions" :countriesData="countriesData" :IndicatorSelected="selectedRiskIndicator" :regionsSelected="selectedRegions" :flipped="false" :key="selectedRiskIndicator+'-'+selectedRegions" :disableTitle="true" :sort="riskSorted" @sortDone="riskSortDone" :arbitraryOrder="arbitraryRiskOrder" @arbitrarySortDone="arbitraryRiskSortDone"/>
    <!-- <hr> -->
        <ComparisonBar style="max-width:100%; max-height: 20rem" :id="'Opportunity-Comparison-Bar'" :regions="regions" :countriesData="countriesData" :IndicatorSelected="selectedOpportIndicator" :regionsSelected="selectedRegions" :flipped="true" :key="selectedOpportIndicator+'-'+selectedRegions" :disableTitle="true" :sort="opportunitySorted" @sortDone="opportSortDone" :arbitraryOrder="arbitraryOpportOrder" @arbitrarySortDone="arbitraryOpportSortDone"/>

    </div>
    </div>
    
    </template>
      
      <script>
      /* eslint-disable */
      import IndicatorName from '@/views/app.json'
      import IndicatorOpportName from '@/views/app_opport.json'
      import ComparisonBar from './ComparisonBar.vue'
      import MenuDropDown from '../UI/MenuDropDownMul'
      import IndicatorDropDown from '../UI/MenuDropDownIndicator'
      import AlertMessage from '../UI/AlertMessage.vue'
      import api from '@/services/api'

      
      export default {
        components: {
          MenuDropDown,
          ComparisonBar,
          IndicatorDropDown,
          AlertMessage
        },
        data() {
          return {
            regions: [],
            regionsorg: [],
            country: [],
            path: 'country-comparison',
            countriesData : {},
            data: IndicatorName,
            dataOpport: IndicatorOpportName,
            indicatorSave: '',
            regionSave: '',
            receivedDataId: this.$route.params.indicator,
            receivedDataRe: this.$route.params.region,
            has_error: false,
            errorMessage: 'Please select an Indicator and a Region',
            selected: "single",
            selectedRiskIndicator: 'overallcountryrisk',
            selectedOpportIndicator: 'opport',
            riskTitle: '',
            opportTitle: '',
            selectedRegions: 'Western Europe',
            opportunitySorted: false,
            riskSorted: false,
            arbitraryRiskOrder: [],
            arbitraryOpportOrder: [],
            currentSort: 'risk'
          }
        },
        methods: {
          toggleSort(){
            if(this.currentSort == 'risk'){
              this.currentSort = 'opport'
              this.sortOpportunity()
            } else if(this.currentSort == 'opport'){
              this.currentSort = 'risk'
              this.sortRisk()
            }
          },
          sortOpportunity(){
            this.opportunitySorted = true
          },
          opportSortDone(arbitraryOrder){
            this.opportunitySorted = false
            this.arbitraryRiskOrder = arbitraryOrder
          },
          arbitraryOpportSortDone(){
            this.arbitraryOpportOrder = []
          },
          arbitraryRiskSortDone(){
            this.arbitraryRiskOrder = []
          },
          sortRisk(){
            this.riskSorted = true
          },
          riskSortDone(arbitraryOrder){
            this.riskSorted = false
            this.arbitraryOpportOrder = arbitraryOrder
          },
          select(code){
            this.selected = code
          },
          selectRiskIndicator(id){
            this.selectedRiskIndicator = id
            if(this.currentSort == 'risk'){
              setTimeout(() => {
                this.sortRisk()
              }, 2500)
            } else if(this.currentSort == 'opport'){
              setTimeout(() => {
                this.sortOpportunity()
              }, 2500)
            }
          },
          selectOpportIndicator(id){
            this.selectedOpportIndicator = id
            if(this.currentSort == 'risk'){
              setTimeout(() => {
                this.sortRisk()
              }, 2500)
            } else if(this.currentSort == 'opport'){
              setTimeout(() => {
                this.sortOpportunity()
              }, 2500)
            }
          },
          selectRegion(regions){
            this.selectedRegions = regions.join()
            if(this.currentSort == 'risk'){
              setTimeout(() => {
                this.sortRisk()
              }, 2500)
            } else if(this.currentSort == 'opport'){
              setTimeout(() => {
                this.sortOpportunity()
              }, 2500)
            }
          },
          triggerComparison() {
            // Call the methods that handle data from children
            this.$refs.menuDropDownRef.notifyChild();
      
            // Check if both receivedDataId and receivedDataRe are defined
            // if (this.receivedDataId !== undefined && this.receivedDataRe !== undefined) {
            //   // Update the route and reload the page
            //   this.$router.push(`/${this.path}/${this.receivedDataRe}/${this.receivedDataId}`).then(() => {
            //     window.location.reload();
            //   });
            // }
          },
          handleDataFromChildID(data) {
            this.receivedDataId = data;
            this.$refs.menuDropDownRef.notifyChild();
            if (this.receivedDataId !== undefined && this.receivedDataRe !== undefined) {
              this.$router.push(`/${this.path}/${this.receivedDataRe}?risk=${this.receivedRiskDataId}&opport=${this.receivedOpportDataId}`).then(() => {
              window.location.reload()
              })
            }
          },
          handleDataFromChildRE(data) {
            this.receivedDataRe = data;
            if (this.receivedDataId !== undefined && this.receivedDataRe !== undefined) {
              this.$router.push(`/${this.path}/${this.receivedDataRe}/${this.receivedDataId}`).then(() => {
              window.location.reload()
              })
            }
          },
          error(data) {
            this.has_error = data
          },
          compare() {
            if (this.receivedDataId == '' || this.receivedDataRe == '') {
              this.has_error = true;
            } else { 
                this.$router.push(`/${this.path}/${this.receivedDataRe}/${this.receivedDataId}`).then(() => {
                window.location.reload()
              });
            }
          },
          async getRegions() {
            try {
              const response = await api.get('/regions');
              const data = await response.data;
              this.regions = data.data.map(item => [item.name]).filter(item => item[0] !== 'World');;
            } catch (error) {
              console.error('Error retrieving regions:', error);
            }
          },
          async getRegionsOrg() {
            try {
              const response = await api.get('/regions?isorg=1');
              const data = await response.data;
              this.regionsorg = data.data.map(item => [item.name]);
            } catch (error) {
              console.error('Error retrieving regions:', error);
            }
          },
          async getAllCountries() {
            try {
              const response = await api.get('/countries?cnttype=REG');
              const data = await response.data;
              this.country = data.data.map(item => [item.country_name]);
            } catch (error) {
              console.error('Erreur lors de la récupération des pays :', error);
            }
          },
          async getCountries() {
              try {
                  const response = await api.get('/countries');
                  const data = await response.data;
      
                  this.countriesData  = data
              } catch (error) {
                  console.error('Error retrieving countries:', error);
              }
          },
        },
        mounted() {
          this.getRegions();
          this.getRegionsOrg();
          this.getCountries()
          this.getAllCountries()
          setTimeout(() => {
            this.sortRisk();
          }, 5000)
        }
      }
      </script>

      <style scoped>


    .language-switcher {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 10px;
    }

 

    .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    }

    .switch input {
    opacity: 0;
    width: 0;
    height: 0;
    }

    .slider {
    position: absolute;
    cursor: pointer;
    background-color: #2196F3; /* Always blue */
    border-radius: 20px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.4s;
    }

    .slider::before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    border-radius: 50%;
    transition: 0.4s;
    }

    input:checked + .slider::before {
    transform: translateX(20px);
    }







</style>